module.exports = __webpack_public_path__ + "static/img/samajuri (43).981a263.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (43).jpg
// module id = H6b8
// module chunks = 0